import { getExtraFormElementCo2Scope3 } from '../custom/extra_form_element_co2_scope3';
import { getExtraFormElementVsme } from '../custom/extra_form_element_vsme';

export function getExtraFormElement(
    entity: string, item: any, data: any, WFormProps?: any, callback?: (data: any) => void, contextService?: any, filter?: any
): any {
    let elements: any = {};
    WFormProps = WFormProps || {};
    elements = getExtraFormElementVsme(entity, item, data, contextService, filter) || {};
    elements = { ...elements, ...(getExtraFormElementCo2Scope3(entity, item, data, WFormProps, callback) || {}) };

    return elements;
}
